import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/lib/i18n";

export const RequireAuth = ({ children, roles, staff = false }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="min-h-screen bg-cream-50 p-10 text-ink-500" role="status" data-testid="auth-loading">{t("common.loading")}</div>;
  }
  if (user === false) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }
  if (roles && !user.roles.some((r) => roles.includes(r))) {
    return (
      <div className="min-h-screen bg-cream-50 p-10" data-testid="forbidden">
        <h1 className="text-3xl">You Do Not Have Access To This Area</h1>
        <p className="mt-3 text-ink-500">If you believe you should, please contact the Care Director.</p>
      </div>
    );
  }
  if (staff && user.mfa_enrollment_required && location.pathname !== "/account/security") {
    return <Navigate to="/account/security" replace state={{ required: true }} />;
  }
  return children;
};
